import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { admin, member, loading } = useAuth();

  // =========================
  // GLOBAL LOADING STATE
  // =========================
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-brand border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm text-ink-muted">Loading...</p>
        </div>
      </div>
    );
  }

  // =========================
  // ADMIN PROTECTION
  // =========================
  if (role === "admin") {
    const token = localStorage.getItem("ospf_admin_token");

    if (!token) {
      return <Navigate to="/admin/login" replace />;
    }

    // wait for admin to load
    if (!admin) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream">
          <div className="text-center">
            <div className="w-10 h-10 border-4 border-brand border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-sm text-ink-muted">
              Loading admin dashboard...
            </p>
          </div>
        </div>
      );
    }

    return children;
  }

  // =========================
  // MEMBER PROTECTION
  // =========================
  if (role === "member") {
    const token = localStorage.getItem("ospf_member_token");

    // ❌ No token → go to login
    if (!token) {
      return <Navigate to="/member/login" replace />;
    }

    // ⏳ Token exists but member not loaded yet (still hydrating).
    // loading=false + member=null means boot() finished but got a 5xx/timeout
    // from Render cold start. Show a retry prompt instead of spinning forever.
    if (!member) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream">
          <div className="text-center space-y-4">
            <div className="w-10 h-10 border-4 border-brand border-t-transparent rounded-full animate-spin mx-auto"></div>
            <p className="text-sm text-ink-muted">
              Server is waking up, please wait…
            </p>
            <button
              onClick={() => window.location.reload()}
              className="text-xs text-brand underline"
            >
              Retry
            </button>
          </div>
        </div>
      );
    }

    return children;
  }

  // =========================
  // GENERIC PROTECTION
  // =========================
  if (!admin && !member) {
    return <Navigate to="/" replace />;
  }

  return children;
}